import { buildFineArrowFrame, unprojectFineArrowRing, } from "./fine-arrow-frame.js";
import { resolveFineArrowParameters, } from "./fine-arrow.js";
import { isSimpleRing } from "./ring.js";
import { add, scale, subtract } from "./vector.js";
export const DEFAULT_TAILED_FINE_ARROW_PARAMETERS = {
    ...resolveFineArrowParameters(),
    tailNotchRatio: 0.9,
};
export function resolveTailedFineArrowParameters(parameters = {}) {
    const fine = resolveFineArrowParameters(parameters);
    const tailNotchRatio = parameters.tailNotchRatio ?? 0.9;
    if (!Number.isFinite(tailNotchRatio) ||
        tailNotchRatio < 0.05 ||
        tailNotchRatio > 4) {
        throw new RangeError("tailNotchRatio must be between 0.05 and 4.");
    }
    return {
        ...fine,
        tailNotchRatio,
    };
}
/**
 * Builds a two-point fine arrow with a centered inward swallowtail notch.
 */
export function buildTailedFineArrowRing(tail, tipPosition, parameters = {}) {
    const resolved = resolveTailedFineArrowParameters(parameters);
    const frame = buildFineArrowFrame(tail, tipPosition, resolved);
    const fullTailWidth = frame.tailHalfWidth * 2;
    const notchDepth = fullTailWidth * resolved.tailNotchRatio;
    const shaftLength = Math.hypot(frame.head.neckCenter.x - frame.tailCenter.x, frame.head.neckCenter.y - frame.tailCenter.y);
    if (notchDepth >= shaftLength * 0.8) {
        throw new RangeError("tailNotchRatio creates a notch that extends too far into the arrow body.");
    }
    const tailLeft = add(frame.tailCenter, scale(frame.normal, frame.tailHalfWidth));
    const tailRight = add(frame.tailCenter, scale(frame.normal, -frame.tailHalfWidth));
    const notch = add(frame.tailCenter, scale(frame.direction, notchDepth));
    const ring = [
        tailLeft,
        frame.head.neckLeft,
        frame.head.headLeft,
        frame.head.tip,
        frame.head.headRight,
        frame.head.neckRight,
        tailRight,
        notch,
        tailLeft,
    ];
    // The notch must remain behind the neck centre in the direction of travel.
    const notchToNeck = subtract(frame.head.neckCenter, notch);
    if (notchToNeck.x * frame.direction.x + notchToNeck.y * frame.direction.y <= 0) {
        throw new RangeError("The swallowtail notch must remain behind the arrow neck.");
    }
    if (!isSimpleRing(ring)) {
        throw new RangeError("The tailed fine arrow parameters create a self-intersecting polygon.");
    }
    return unprojectFineArrowRing(frame, ring, tipPosition, 3);
}
//# sourceMappingURL=tailed-fine-arrow.js.map